module.exports = __webpack_public_path__ + "img/dcms02.e9808cab.png";